import React from 'react';
import WarningIcon from 'assets/icons/alertWarning-icon.svg';
import { HtmlText, formatText } from 'core/i18n';
import './alertWarning.scss';

function alertWarning({ title, description }) {
    return (
        <div className="alert-warning-container">
            <img className="alert-warning-img" src={WarningIcon} alt="alert-warning" />
            <div>
                <h1 className="alert-warning-tile">{HtmlText(formatText(title))}</h1>
                <p className="alert-warning-description">{HtmlText(formatText(description))}</p>
            </div>
        </div>
    );
}

export default alertWarning;
